import { mensagemDeErro } from '@common/errors/mensagemDeErro';
import {
  Alert,
  Button,
  FormField,
  Modal,
  Select,
  SelectItem,
  Spinner,
} from '@ntconsult/aluma-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePreviaConvite } from '../hooks';
import { IDIOMAS } from '../hooks/useFiltrosParticipantes';
import type { Idioma } from '../types/Painel';
import { PreviaAoVivo } from './PreviaAoVivo';

type Props = {
  campanhaId: string;
  open: boolean;
  /** Sem participante, a prévia usa um nome de exemplo. */
  participanteId?: string;
  onClose: () => void;
};

/**
 * Spec 17 e spec 30 R18: assunto, remetente, destinatário e o e-mail em tamanho real, gerados pela
 * API com o mesmo código do envio.
 */
/** O idioma começa no do participante (ou PT); o seletor troca (spec 25 R15). */
export function PreviaEmailModal({ campanhaId, open, participanteId, onClose }: Props) {
  const { t } = useTranslation(['convites', 'participantes', 'common', 'erros']);
  const [escolhido, setEscolhido] = useState<Idioma | undefined>(undefined);
  const { data, isLoading, isError, error } = usePreviaConvite(
    campanhaId,
    participanteId,
    open,
    escolhido,
  );
  return (
    <Modal open={open} onClose={onClose} size="2xl" ariaLabel={t('convites:previa.titulo')}>
      <Modal.Header
        title={t('convites:previa.titulo')}
        onClose={onClose}
        dismissLabel={t('common:close')}
      />
      <Modal.Body>
        <div className="flex flex-col gap-4 text-sm">
          {isLoading && <Spinner label={t('common:loading')} />}
          {isError && <Alert variant="danger" title={t(`erros:${mensagemDeErro(error)}`)} />}
          {data && (
            <>
              <FormField label={t('convites:idioma.previa')}>
                <Select
                  value={escolhido ?? data.idioma}
                  onValueChange={(v) => setEscolhido(v as Idioma)}
                >
                  {IDIOMAS.map((i) => (
                    <SelectItem key={i} value={i}>
                      {t(`participantes:idiomas.${i}`)}
                    </SelectItem>
                  ))}
                </Select>
              </FormField>
              {data.problemaDestinatario && (
                <Alert variant="warning" title={t('convites:previa.semDestinatario')} />
              )}
              <PreviaAoVivo
                previa={data}
                para={data.destinatario ?? (participanteId ? '—' : t('convites:previa.exemplo'))}
              />
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
